var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('VCleaveInput',_vm._g(_vm._b({attrs:{"hide-details":"auto","dense":"","options":_vm.options,"loading":_vm.loading}},'VCleaveInput',_vm.$attrs,false),_vm.$listeners))}
var staticRenderFns = []

export { render, staticRenderFns }